<template lang="pug">
.container-fluid
	.row(v-if="produccion")
		.col-xs-12.col-sm-12.col-md-6.col-lg-4.col-xl-4
			editor-orden(:produccion.sync="produccion", @actualizar="emiteActualizar()", :editando="idOrden", @nueva="nuevaProduccion()")
		.col-xs-12.col-sm-12.col-md-6.col-lg-8.col-xl-8(v-if="produccion.ID_produccion")
			.card
				.card-header.bg-info.text-white Tareas
				.card-body.text-left(:class="(index % 2 == 0) ? 'bg-light' : ''", v-for="(tarea, index) in produccion.tareas", :key="tarea.ID_tarea")
					tarea(:tarea.sync="produccion.tareas[index]", :index="index", @quitar="quitarTarea(index)", @actualizar="emiteActualizar()")
				.card-footer
					.row
						.col.text-left
							button.btn.btn-sm.btn-dark(@click="finalizar()")
								span.fa.fa-close
								| Finalizar edición
						.col.text-right
							button.btn.btn-sm.btn-primary(@click="nuevaTarea()")
								span.fa.fa-plus
								| Nueva tarea
		div.col-xs-12.col-sm-12.col-md-6.col-lg-8.col-xl-8(v-if="!produccion.ID_produccion")
			div.alert.alert-warning
				b Información
				p.text-left
					| Para crear una nueva producción primero tienes que completar los campos básicos:
					ul
						li Asigna un anunciante
						li Asocia la producción a un contrato (opcional)
						li Completa los datos básicos; titulo, fecha de inicio, fin y descripción
						li Añade ficheros que puedan ayudar en el proceso de producción
					| Una vez completes estos pasos, podrás agregar las tareas que correspondan.
</template>


<script>
import EditorOrden from './orden'
import Tarea from './tarea'
import API from '../../services/api'

export default {
	props: ['idOrden'],
	components: {
		'tarea': Tarea,
		'editor-orden': EditorOrden
	},
	data: function () {
		return {
			produccion: null,
			nuevaTareaIndex: 1,
			nuevoFicheroIndex: 1,
			verAsociar: false
		}
	},

	created () {
		if (this.idOrden) {
			// Hemos recibido una órden, por lo que vamos a cargarla
			API.getProduccion(this.idOrden)
				.then(res => {
					this.produccion = res.data.produccion
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		} else {
			this.nuevaProduccion()
		}
	},

	methods: {
		nuevaProduccion () {
			this.produccion = {
				ID_produccion: null,
				titulo: null,
				publica: 0,
				externa: 0,
				contrato: {
					ID_contrato: null,
					titulo: null,
					nombreCliente: null
				},
				anunciante: {
					ID_anunciante: null,
					nombre: null
				},
				descripcion: null,
				agente: {
					ID: null,
					nombre: null
				},
				ficheros: [],
				tareas: []
			}
		},

		nuevaTarea () {
			const tarea = {
				produccion_ID: this.produccion.ID_produccion,
				ID_tarea: null,
				tipo: null,
				descripcion: null,
				fecha_inicio: new Date(),
				fecha_fin: new Date()
			}

			API.setTarea(tarea)
				.then(res => {
					this.produccion.tareas.push(res.data.tarea)
					this.emiteActualizar()
				})
				.catch(e => {
					console.error(e)
				})
		},

		quitarTarea (i) {
			this.produccion.tareas.splice(i, 1)

			if (this.produccion.tareas.length === 0) {
				// Se ha eliminado la producciópn también
				this.nuevaProduccion()
			}
		},

		emiteActualizar () {
			this.$emit('actualizar')
		},

		finalizar () {
			this.nuevaProduccion()
			this.$emit('cerrar')
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/nueva/nueva.vue